@if (events$ | async) {}
<div class="st-menu-collapse-item flex flex-column w-full">
  <a
    class="st-menu-collapse-item-header w-full flex align-items-center cursor-pointer py-6px px-12px"
    (click)="collapse()"
    [ngClass]="{ 'st-menu-collapse-item-active': isActive() }"
    [routerLink]="
      menuItemData().isOutSideUrl || menuItemData().children.length
        ? null
        : [menuItemData().routeUrl]
    "
  >
    <a
      class="flex gap-2 align-items-center flex-1"
      (click)="
        navigateToMicroService(menuItemData(), !!menuItemData().children.length)
      "
    >
      <em [class]="menuItemData().iconClass"></em>
      <div class="webkit-box-one-line label-large-bold">
        {{ menuItemData().name }}
      </div>
    </a>
    @if (menuItemData().children.length) {
      <em
        class="ml-auto ph"
        [ngClass]="{
          'ph-caret-up': !isCollapsed(),
          'ph-caret-down': isCollapsed(),
        }"
      ></em>
    }
  </a>
  @if (menuItemData().children.length) {
    <div
      class="st-menu-collapse-item-body w-full flex flex-column align-items-center"
      zCollapsible
      [isCollapsed]="isCollapsed()"
    >
      @for (item of menuItemData().children; track $index) {
        <a
          class="st-menu-collapse-item-body-element w-full flex align-items-center gap-2"
          [ngClass]="{
            'st-menu-collapse-item-body-element-active':
              activeChild?.id === item.id,
          }"
          [routerLink]="item.isOutSideUrl ? null : [item.routeUrl]"
          (click)="navigateToMicroService(item, !!item.children.length)"
        >
          <div class="st-menu-collapse-item-body-element-left-side">
            <div class="top-line"></div>
            <div class="st-menu-collapse-item-body-element-left-side-dot"></div>
            <div class="bottom-line"></div>
          </div>
          <div
            class="st-menu-collapse-item-body-element-name label-large-regular webkit-box-one-line"
          >
            {{ item.name }}
          </div>
        </a>
      }
    </div>
  }
</div>
